import {createElement} from 'react';
import {Navigate, RouteObject} from 'react-router-native';
import {
  Account,
  CancelBoxFlow,
  Checkout,
  CheckoutPreview,
  DeleteAccountConfirm,
  DeleteAccountError,
  DeleteAccountInfo,
  DeleteAccountSuccess,
  Login,
  LookIn,
  MyLookiero,
  PlacedOrder,
  TrackingOrder,
  MyPlan,
  ProfileMenu,
  PublicReturnOrder,
  Quiz,
  QuizRegister,
  Referrals,
  ReferralsSummary,
  ResetPassword,
  StyleProfile,
} from './routes.components';
import {MyAreaSlug, Path, withWildcard} from './routes.definition';
import {FaqsEntry, SupportEntry} from './components/SupportRoutes';

interface RouteHandle {
  // `'any'` keeps the route outside both auth guards: it is served in either session state and
  // decides what to render itself (see SupportRoutes).
  readonly authorization: boolean | 'any';
}

const COMMON_ROUTE_CONFIG: ReadonlyArray<RouteObject & {handle: RouteHandle}> = [
  {path: Path.LOGIN, element: createElement(Login), handle: {authorization: false}},
  {path: Path.QUIZ_HOME, element: createElement(Quiz), handle: {authorization: false}},
  {path: withWildcard(Path.QUIZ), element: createElement(Quiz), handle: {authorization: false}},
  {path: Path.QUIZ_REGISTER, element: createElement(QuizRegister), handle: {authorization: false}},
  {path: Path.RECOVER_PASSWORD, element: createElement(ResetPassword), handle: {authorization: false}},
  {path: Path.RETURN_ORDER, element: createElement(PublicReturnOrder), handle: {authorization: false}},
  {
    path: Path.HOME,
    element: createElement(MyLookiero),
    handle: {authorization: true},
    children: [
      {path: MyAreaSlug.PLACED, element: createElement(PlacedOrder)},
      {path: MyAreaSlug.TRACKING, element: createElement(TrackingOrder)},
      {path: MyAreaSlug.CHECKOUT_PREVIEW, element: createElement(CheckoutPreview)},
      {path: '*', element: createElement(Navigate, {to: Path.HOME, replace: true})},
    ],
  },
  {path: Path.REFERRALS, element: createElement(Referrals), handle: {authorization: true}},
  {path: Path.REFERRALS_SUMMARY, element: createElement(ReferralsSummary), handle: {authorization: true}},
  {path: withWildcard(Path.STYLE_PROFILE), element: createElement(StyleProfile), handle: {authorization: true}},
  {path: Path.ACCOUNT, element: createElement(Account), handle: {authorization: true}},
  {path: Path.PROFILE_MENU, element: createElement(ProfileMenu), handle: {authorization: true}},
  {path: withWildcard(Path.LOOK_IN), element: createElement(LookIn), handle: {authorization: true}},
  {path: withWildcard(Path.CHECKOUT), element: createElement(Checkout), handle: {authorization: true}},
  {path: Path.ACCOUNT_MY_PLAN, element: createElement(MyPlan), handle: {authorization: true}},
  {path: Path.DELETE_ACCOUNT, element: createElement(DeleteAccountInfo), handle: {authorization: true}},
  {
    path: Path.DELETE_ACCOUNT_CONFIRM,
    element: createElement(DeleteAccountConfirm),
    handle: {authorization: true},
  },
  {
    path: Path.DELETE_ACCOUNT_SUCCESS,
    element: createElement(DeleteAccountSuccess),
    handle: {authorization: false},
  },
  {path: Path.DELETE_ACCOUNT_ERROR, element: createElement(DeleteAccountError), handle: {authorization: true}},
  {path: Path.FAQS, element: createElement(FaqsEntry), handle: {authorization: 'any'}},
  {path: Path.SUPPORT, element: createElement(SupportEntry), handle: {authorization: 'any'}},
  {path: Path.CANCEL_BOX_FLOW, element: createElement(CancelBoxFlow), handle: {authorization: true}},
];

export {COMMON_ROUTE_CONFIG};
export type {RouteHandle};
